import React, { PureComponent } from 'react';
import { When } from 'react-if';
import PropTypes from 'prop-types';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import { doSignInWithEmailAndPassword } from '../../../../firebase/api/auth';
import { compose } from 'recompose';
import WithRouter from '../../../../helpers/WithRouter';
import * as ROUTES from '../../../../constants/routes';

class SignInBody extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            error: null,
        };
    }

    onSubmit = event => {
        const { email, password } = this.state;
        const { previewPostUid, navigate } = this.props;
        doSignInWithEmailAndPassword(email, password)
            .then(() => {
                this.props.setAuthLoading(true);
                navigate(!!this.props.redirectLink.length ? this.props.redirectLink : ROUTES.POSTS);
                this.props.toggle();
            })
            .catch(error => {
                this.setState({ error });
            });
        event.preventDefault();
    };

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {
        const { email, password, error } = this.state;
        const isInvalid = password === '' || email === '';
        const { redirectToSignUp, redirectToForgotPassword } = this.props;

        return (
            <div>
                <Form action="" method="post" name="login" onSubmit={this.onSubmit}>
                    <FormGroup>
                        <Label for="exampleEmail">Email address</Label>
                        <Input
                            type="email"
                            name="email"
                            onChange={this.onChange}
                            id="exampleEmail"
                            placeholder="Email"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="examplePassword">Password</Label>
                        <Input
                            type="password"
                            onChange={this.onChange}
                            name="password"
                            id="examplePassword"
                            placeholder="Password"
                        />
                    </FormGroup>
                    <div className="submit-button">
                        <When condition={this.props.hasForgotPasswordButton}>
                            <Button
                                className="forgot"
                                outline
                                color="primary"
                                onClick={redirectToForgotPassword}
                            >
                                Forgot password?
                            </Button>
                        </When>
                        <Button
                            type="submit"
                            color="primary"
                            disabled={isInvalid}
                            className="submit"
                        >
                            Sign In
                        </Button>
                    </div>
                    <div className="form-group text-center">
                        <span className="sign-in-message">
                            If you haven't got an account you can{' '}
                            <span
                                className={'redirect-to-sign-up cursor-pointer'}
                                onClick={() => redirectToSignUp()}
                            >
                                sign-up here
                            </span>
                        </span>
                    </div>
                    {error && <p>{error.message}</p>}
                </Form>
            </div>
        );
    }
}

SignInBody.propTypes = {};

SignInBody.defaultProps = {
    hasForgotPasswordButton: true,
};

export default compose(WithRouter)(SignInBody);
